/**
 * location controller mixin
 */

/**
 * locationCtrlMixinFactory
 * returns locationCtrlMixin mixin factory
 *
 * @class locationCtrlMixinFactory
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc factory
 * @name mwApp/common.factory:locationCtrlMixinFactory
 */
/* @ngInject */
export default function locationCtrlMixinFactory ($log, $location, $state, $stateParams, $window, authSvc, historySvc) {
  /**
   * Location factory for entity
   *
   * @param  {models.Entity} e - entity
   * @return {Object}
   * @memberof mwApp/common.mixin:locationCtrlMixin.location
   */
  function entityLocation (e) {
    var vm = this
    return {

      reload: function () {
        if (vm.isNew === undefined) {
          $log.error('.reload() method requires "isNew" field in controller')
        }

        // TODO: revert 430012417b836aa25622f98e77d1679630eb758f
        // const hash = window.location.hash
        // const hash = $location.hash();

        if (vm.isNew) {
          const permissionConstructor = {
            VOD: 'Vod',
            Show: 'VodSeries',
            Season: 'VodSeries',
            Episode: 'VodSeries',
            SeasonEpisode: 'VodSeries',
            ChannelDTO: 'Channel',
            SubscriptionAccessory: 'Subscription'
          }
          const permission = 'edit' + (permissionConstructor[e.constructor._name] || e.constructor._name)
          if (authSvc.hasAccess(permission)) {
            // $location.url(e._publicUrl + hash)
            $location.url(e._publicUrl)
          } else {
            // $location.url(e._publicListUrl + hash)
            $location.url(e._publicListUrl)
          }
        } else {
          // $window.location.reload(true)
          // $state.go('new-personal-orders', {'#': catId });
          $state.go($state.current, {}, {
            reload: true
          })
        }
      },

      list: function () {
        $location.url(e._publicListUrl)
      },

      back: function () {
        $location.url(e._publicListUrl)
      }

    }
  }

  /**
   * Go back by history
   *
   * @memberof mwApp/common.mixin:locationCtrlMixin.location
   */
  entityLocation.back = function () {
    historySvc.back()
  }

  /**
   * Check if is possible to go back by history to specific name
   *
   * @memberof mwApp/common.mixin:locationCtrlMixin.location
   * @param  {String} name - title for new history entry
   */
  entityLocation.canPop = function (name) {
    return historySvc.canPop(name)
  }

  /**
   * Go back by history to specific name
   *
   * @memberof mwApp/common.mixin:locationCtrlMixin.location
   * @param  {String} name - title for new history entry
   */
  entityLocation.pop = function (name) {
    historySvc.pop(name)
  }

  /**
   * Reload location
   *
   * @memberof mwApp/common.mixin:locationCtrlMixin.location
   */
  entityLocation.reload = function () {
    $state.restoreHash = $location.hash().trim()
    // Note: $state.reload() change $location to previous hash (if change hash to '')!
    setTimeout(() => { $state.go($state.current, {}, { reload: true }) }, 100)
  }

  entityLocation.goBackLink = ''

  entityLocation.setGoBackLink = function (link) {
    this.goBackLink = link
  }

  entityLocation.goBack = function () {
    if (this.canPop()) {
      this.back()
    } else {
      $location.url(this.goBackLink)
    }
  }

  /**
   * Mixin with location controller methods
   *
   * @mixin locationCtrlMixin
   * @memberof mwApp/common
   * @see mwApp/common
   * @name mwApp/common.mixin:locationCtrlMixin
   *
   * @type {Object}
   */
  return {
    location: entityLocation
  }
}
